import './description.scss';

class DescriptionControls {
  constructor(lang, theme) {
    this.lang = lang;
    this.theme = theme;
  }

  buildDescriptionSection(lang, theme) {
    let descriptionSection = document.createElement('section');
    let descriptionWrapper = document.createElement('div');
    let descriptionHeader = document.createElement('h2');
    let descriptionTextHeader = document.createElement('h3');
    let descriptionGameText = document.createElement('p');
    let descriptionWebsiteText = document.createElement('p');
    let descriptionImage = document.createElement('div');
    let mainSection = document.querySelector('.main-section');

    descriptionSection.classList.add('descr-section');
    descriptionWrapper.classList.add('descr-section__text-wrapper');
    descriptionHeader.classList.add('descr-section__header');
    descriptionTextHeader.classList.add('descr-section__desription-header');
    descriptionGameText.classList.add('descr-section__game-descr');
    descriptionWebsiteText.classList.add('descr-section__website-descr');
    descriptionImage.classList.add('descr-section__img');

    if (theme === 'dark') {
      descriptionSection.classList.add('descr-section_theme-color_dark');
      descriptionHeader.classList.add('descr-section__header_theme-color_dark');
      descriptionTextHeader.classList.add('descr-section__desription-header_theme-color_dark');
      descriptionGameText.classList.add('descr-section__game-descr_theme-color_dark');
      descriptionWebsiteText.classList.add('descr-section__website-descr_theme-color_dark');
    } else {
      descriptionSection.classList.add('descr-section_theme-color_light');
      descriptionHeader.classList.add('descr-section__header_theme-color_light');
      descriptionTextHeader.classList.add('descr-section__desription-header_theme-color_light');
      descriptionGameText.classList.add('descr-section__game-descr_theme-color_light');
      descriptionWebsiteText.classList.add('descr-section__website-descr_theme-color_light');
    }

    if (lang === 'ru') {
      descriptionHeader.classList.add('descr-section__header_lang_ru');
      descriptionTextHeader.classList.add('descr-section__desription-header_lang_ru');
      descriptionGameText.classList.add('descr-section__game-descr_lang_ru');
      descriptionWebsiteText.classList.add('descr-section__website-descr_lang_ru');
    } else {
      descriptionHeader.classList.add('descr-section__header_lang_en');
      descriptionTextHeader.classList.add('descr-section__desription-header_lang_en');
      descriptionGameText.classList.add('descr-section__game-descr_lang_en');
      descriptionWebsiteText.classList.add('descr-section__website-descr_lang_en');
    }

    descriptionWrapper.appendChild(descriptionHeader);
    descriptionWrapper.appendChild(descriptionTextHeader);
    descriptionWrapper.appendChild(descriptionGameText);
    descriptionWrapper.appendChild(descriptionWebsiteText);
    descriptionSection.appendChild(descriptionWrapper);
    descriptionSection.appendChild(descriptionImage);
    mainSection.appendChild(descriptionSection);
  }
}

export { DescriptionControls };
